import { amplitudeTrack } from '@cw-elements/analytics-provider';

const COMPONENT = 'Accounts';

/**
 * Amplitude "user add ..." events fired as the user fills the sign-up profile
 * form. These are client-only field interactions (no server round-trip), so
 * they are tracked here rather than from the controller. Each entry maps a
 * register-form field to its DOM trigger, Amplitude event name, and the extra
 * event properties derived from the field value.
 *
 * @type {{id: string, on: string, event: string, props: (el: HTMLElement) => object}[]}
 */
export const SIGNUP_FIELD_EVENTS = [
  {
    id: 'first_name', on: 'focus', event: 'user add first name', props: () => ({}),
  },
  {
    id: 'last_name', on: 'focus', event: 'user add last name', props: () => ({}),
  },
  {
    id: 'job_title',
    on: 'change',
    event: 'user add job title',
    // The department picker submits a department alongside the job title,
    // since a title (e.g. MANAGER) only has meaning inside its department.
    props: (el) => {
      const department = el.ownerDocument?.getElementById('department')?.value;
      return department ? { 'job title': el.value, department } : { 'job title': el.value };
    },
  },
  {
    id: 'country_code',
    on: 'change',
    event: 'user add location of residence',
    props: (el) => ({ country: el.value }),
  },
  {
    id: 'phone',
    on: 'focus',
    event: 'user add mobile number',
    // The SPA sent no country here, but the tracking plan asks for one; use the
    // residence country (same value as "user add location of residence"), read
    // via the field's own document so it stays unit-testable.
    props: (field) => ({
      country: field.ownerDocument.getElementById('country_code')?.value ?? '',
    }),
  },
];

/**
 * Attaches the sign-up field-interaction Amplitude trackers. No-ops on pages
 * that do not render the register form (the fields are absent).
 */
export const initSignupFieldEvents = () => {
  for (const {
    id, on, event, props,
  } of SIGNUP_FIELD_EVENTS) {
    const field = document.getElementById(id);

    field?.addEventListener(on, () => {
      amplitudeTrack(event, { component: COMPONENT, ...props(field) });
    });
  }
};
